import { Popover, PopoverProps } from "@mantine/core";
import { FC, ReactNode, useState } from "react";

// TextInfo component shows a tooltip upon clicking on some text
// It's similar to the "TextPopover" component in brokerage-web

type TextInfoProps = {
  text: ReactNode;
} & Partial<PopoverProps>;
export const TextInfo: FC<TextInfoProps> = (props) => {
  const { text, children, ...popoverProps } = props;
  const [opened, setOpened] = useState(false);
  return (
    <Popover
      opened={opened}
      width={350}
      onClose={() => setOpened(false)}
      classNames={{
        dropdown: "rounded-lg text-frecXDarkGray p-4 shadow-lg w-auto!",
      }}
      transitionProps={{ duration: 0 }}
      {...popoverProps}
    >
      <Popover.Target>
        <button
          className="border-b-frecDarkGray hover:border-b-frecBlack focus:border-frecBlack! text-frecXDarkGray hover:text-frecBlack! inline border-y border-b-2 border-dotted border-t-transparent no-underline! focus:border-t-transparent!"
          onClick={() => setOpened((open) => !open)}
        >
          {text}
        </button>
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  );
};
